import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/** Katalog norm DLC_10 — widoczny tylko z uprawnieniem (CEO/developer/flaga). */
export function TechCalcNormsGuard() {
  const user = useAuthStore((s) => s.user);
  if (user?.has_tech_calc_norms_permission) {
    return <Outlet />;
  }
  return <Navigate to="/tech-calc" replace />;
}
